import React from 'react'
import { useSelector } from 'react-redux'

import { Box, Typography } from '@material-ui/core'

import { selectTariffTotalPrices } from './Sidebar.selectors'
import SidebarAccordion from './SidebarAccordion'
import SidebarCustomerInfo from './SidebarCustomerInfo'
import SidebarMonthToMonth from './SidebarMonthToMonth'
import useStyles from './SidebarStyles'
import SidebarTariffInfo, { SidebarPrice } from './SidebarTariffInfo'
import SidebarWrap from './SidebarWrap'

import { selectTaxName } from '~/prices/store/prices.selectors'
import { selectTariffKeys } from '~/tariff/store/tariff.selectors'

function SidebarTotalPrices({ prices }: { prices: SidebarPrice[] }) {
  const { pill, padding } = useStyles()
  const taxName = useSelector(selectTaxName)

  return prices.length === 1 ? (
    <Box
      width="312px"
      px={3}
      py={6}
      color="white"
      display="flex"
      justifyContent="space-between"
      alignItems="baseline"
    >
      <Box>
        <Typography variant="h4" component={Box} mb={1}>
          Total cuotas
        </Typography>
        <Typography variant="body2">{taxName}</Typography>
      </Box>
      <Box className={pill}>
        <Typography variant="body2">
          <strong>{prices[0].amount}</strong> €/mes
        </Typography>
      </Box>
    </Box>
  ) : (
    <SidebarAccordion
      dataHook="sidebar-total-payments"
      title="Total cuotas"
      subtitle={taxName}
      reducedPadding
    >
      <Box width="100%">
        {prices.map(({ duration, amount }, i) => (
          <SidebarMonthToMonth
            isFinalPrice
            className={i === 0 ? pill : padding}
            duration={duration}
            amount={amount}
            key={`prices-sidebar-${amount}`}
          />
        ))}
      </Box>
    </SidebarAccordion>
  )
}

export default function Sidebar() {
  const ids = useSelector(selectTariffKeys)
  const prices = useSelector(selectTariffTotalPrices)

  return (
    <SidebarWrap>
      <SidebarCustomerInfo />
      {ids.map((id) => (
        <SidebarTariffInfo id={id} key={`tariff-sidebar-${id}`} />
      ))}
      {!!prices.length && <SidebarTotalPrices prices={prices} />}
    </SidebarWrap>
  )
}
